import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import MeusDadosFormView from '@/views/meus-dados/MeusDadosFormView.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'meus-dados',
      name: 'MeusDadosForm',
      component: MeusDadosFormView,
      meta: { 
        requiresAuth: true,
      },
    },
  ],
}
